export function base64UrlEncode(data) {
    const utf8Bytes = new TextEncoder().encode(data);
    const base64 = btoa(String.fromCharCode.apply(null, utf8Bytes));
    const urlSafeBase64 = base64.replace(/\+/g, '-').replace(/\//g, '_');
    return urlSafeBase64.replace(/=+$/, '');
}

export function base64UrlDecode(data) {
    const urlEncodedStr = data.replace(/-/g, '+').replace(/_/g, '/');
    const paddedEncodedStr = urlEncodedStr.padEnd(urlEncodedStr.length + (4 - urlEncodedStr.length % 4) % 4, '=');
    const byteCharacters = atob(paddedEncodedStr);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const utf8Bytes = new Uint8Array(byteNumbers);
    return new TextDecoder().decode(utf8Bytes);
}
